module.exports = __webpack_public_path__ + "static/media/event-location-icon--red.91dda77e.svg";